import * as Semantic from 'semantic-ui-react';
import { useVideoUsage } from 'api/v2/videosApi';
import { PlaylistListItem } from 'containers/composer/compositions/components/modals/CompositionUsage.modal';

interface Props {
  videoId: string;
}

export function VideoUsage({ videoId }: Props) {
  const usageQuery = useVideoUsage(videoId);
  const { isLoading, data, isError, error } = usageQuery;
  const playlists = data?.playlists || [];

  return (
    <>
      <h3>Video Usage</h3>
      {isLoading && (
        <Semantic.Loader inline="centered" active>
          Loading usage...
        </Semantic.Loader>
      )}
      {isError && (
        <Semantic.Message error>
          <Semantic.Message.Header>Failed to load usage information</Semantic.Message.Header>
          <p>{error instanceof Error ? error.message : 'An error occurred while fetching video usage. Please try again.'}</p>
        </Semantic.Message>
      )}
      {!isLoading && !isError && playlists.length === 0 && <Semantic.Message info>This video is not used anywhere.</Semantic.Message>}
      {!isLoading && !isError && playlists.length > 0 && (
        <>
          <p>This video is used in {playlists.length} playlist(s):</p>
          <Semantic.List divided relaxed>
            {playlists.map((playlist) => (
              <PlaylistListItem key={playlist._id} playlist={playlist} />
            ))}
          </Semantic.List>
        </>
      )}
    </>
  );
}
